import type { AxiosInstance } from "axios";
import { API_URL } from "~/env";
import { sendRequest } from "~/utils/axios-utils";

const url = {
  getLawFirmList: `/api/v1/siqPlatform/lawFirmList`, // 深i企律所列表
  getLawFirmDetail: `/api/v1/siqPlatform/lawFirmDetail`, // 深i企律所详情
};

export default ($axios: AxiosInstance) => {
  // 设置 baseURL
  // 注意：这里我们使用 defaults.baseURL 而不是 setBaseURL 方法
  $axios.defaults.baseURL = API_URL;

  return {
    // 深i企律所列表
    getLawFirmList: (params: API.GetLawFirmListParams) =>
      sendRequest($axios, {
        method: "POST",
        url: url.getLawFirmList,
        data: params,
      }),

    // 深i企律所详情
    getLawFirmDetail: (params: API.GetLawFirmDetailParams) =>
      sendRequest($axios, {
        method: "GET",
        url: url.getLawFirmDetail,
        params,
      }),
  };
};
